import type { ForwardRefExoticComponent, ReactElement, RefAttributes } from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import type { LucideProps } from 'lucide-react';
import type { MarkdownRemarkFrontmatterCards } from '../../../generated/types';

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.borderRadius.sm,
  boxShadow: '0px 24px 40px rgba(165,144,255, 0.1)',
  height: 'auto',
  padding: theme.spacing(3),
  position: 'relative',
  width: '100%',
  zIndex: 2,
  [theme.breakpoints.down('md')]: {
    width: '300px',
  },
}));

type PpHomepageCard = MarkdownRemarkFrontmatterCards & {
  Icon: ForwardRefExoticComponent<Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>>;
};

export function HomepageCard({ Icon, subtitle, title }: PpHomepageCard): ReactElement {
  const theme = useTheme();

  return (
    <StyledCard>
      <Icon color={theme.palette.info.main} fontSize="large" size={48} strokeWidth={1} />
      <CardContent sx={{ mt: 6 }}>
        <Stack spacing={2}>
          <Typography variant="headingL">{title}</Typography>
          <Typography color="text.dark" variant="paragraphBodyS">
            {subtitle}
          </Typography>
        </Stack>
      </CardContent>
    </StyledCard>
  );
}
